export type SidebarMessages = {
  dashboard: string;
  sales: string;
  sub_customer_service: string;
  operational: string;
  managerial: string;
  customer_service: string;
  chat: string;
  conversation_report: string;
  contacts: string;
  orders: string;
  sub_orders: string;
  checkout: string;
  catalog: string;
  products: string;
  variations: string;
  categories: string;
  images: string;
  pricing: string;
  price_list: string;
  campaigns: string;
  configurations: string;
  platforms: string;
  message_templates: string;
  company_data: string;
  coverage_areas: string;
  service_queues: string;
  subjects: string;
  contract_now: string;
  users: string;
  robots: string;
  workflow: string;
  integrations: string;
  my_user: string;
  view_messages: string;
  notification_center: string;
  made_with_love: string;
  by: string;
  talk2buy: string;
  terms: string;
  privacy: string;
  talkToSupport: string;
  knowledgeBase: string;
  myAccount: string;
  goOut: string;
  overduePlanMessagePart1: string;
  overduePlanMessagePart2: string;
  renewButtonText: string;
  pendingPaymentMessagePart1: string;
  pendingPaymentMessagePart2: string;
  payNowButtonText: string;
  talk2buyLogo: string;
};

export const SIDEBAR_MESSAGES: SidebarMessages = {
  dashboard: "Dashboard",
  sales: "Vendas",
  sub_customer_service: "Atendimento",
  operational: "Operacional",
  managerial: "Gerencial",
  customer_service: "Atendimento",
  chat: "Conversas",
  conversation_report: "Relatório de conversas",
  contacts: "Contatos",
  orders: "Pedidos",
  sub_orders: "Pedidos",
  checkout: "Checkout",
  catalog: "Catálogo",
  products: "Produtos",
  variations: "Variações",
  categories: "Categorias",
  images: "Imagens",
  pricing: "Precificação",
  price_list: "Lista de Preço",
  campaigns: "Campanhas",
  configurations: "Configuração",
  platforms: "Plataformas",
  message_templates: "Modelos transacionais",
  company_data: "Empresa",
  coverage_areas: "Áreas de Abrangência",
  service_queues: "Filas de Atendimento",
  subjects: "Assuntos",
  contract_now: "CONTRATE AGORA!",
  users: "Usuários",
  robots: "Agentes",
  workflow: "Agentes",
  integrations: "Integrações",
  my_user: "Meu Usuário",
  view_messages: "Ver mensagens",
  notification_center: "Central de notificações",
  made_with_love: "feito com",
  by: "por",
  talk2buy: "Talk2Buy",
  terms: "Termos",
  privacy: "Privacidade",
  talkToSupport: "Fale com o suporte",
  knowledgeBase: "Base de conhecimento",
  myAccount: "Minha conta",
  goOut: "Sair",
  overduePlanMessagePart1: "Seu plano não foi renovado!",
  overduePlanMessagePart2:
    " 😞 Renovar é fácil! Basta clicar no botão ao lado e seguir as instruções para continuar aprimorando sua experiência de vendas conosco. ✨",
  renewButtonText: "Renovar",
  pendingPaymentMessagePart1: "Pagamento pendente!",
  pendingPaymentMessagePart2:
    " Conclua o pagamento da fatura para liberar o uso do plano e continuar vendendo com a Talk2Buy.",
  payNowButtonText: "Pagar agora",
  talk2buyLogo: "Talk2Buy logo",
};
